module.exports = __webpack_public_path__ + "static/media/lapita_text_01.84d44315.jpg";